import { SET_ASSET_SUMMARY, SET_ASSET_TYPES, SET_ASSET_TYPE_SUMMARY, SET_ASSET_GROUPING } from '../constants/actionTypes'
import { AssetGroups } from '../constants/assetGroups'

const initialState = {
  assetSummary: [],
  assetTypes: [],
  assetTypeSummary: [],
  assetGroup: AssetGroups.TYPE
}

const assetInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSET_SUMMARY:
      return Object.assign({}, state, {
        assetSummary: action.assetSummary
      })
    case SET_ASSET_TYPES:
      return Object.assign({}, state, {
        assetTypes: action.assetTypes
      })
    case SET_ASSET_TYPE_SUMMARY:
      return Object.assign({}, state, {
        assetTypeSummary: action.assetTypeSummary
      })
    case SET_ASSET_GROUPING:
      return Object.assign({}, state, {
        assetGroup: action.assetGroup
      })
    default:
      return state
  }
}

export default assetInfo
